import { CButton, CRow,CCol, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody,CModalFooter,CFormLabel,CFormSelect,CFormInput, CFormText, CFormCheck, CContainer, CCardHeader } from "@coreui/react";
import { CNav,CNavItem,CNavLink,CTabContent,CTabPane } from "@coreui/react";
import React, { useEffect } from "react";

import './Patient.css'
import { Button } from "antd";
import { useState, useRef } from "react";
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import './schedulerHelper'

import syncServiceLocationFromKareo from '../../services/general/syncServiceLocation.api'


const ServiceLocationKareo = () => {

  const [showPracticeOptions,setPracticeOptions] = useState(true)
  const dateFormat = 'DD/MM/YYYY';

    const buttonList = []
    const [dateVisible, setDateVisible] = useState(false)
    const [patientID, setPatientID] = useState("")
    const [loading, setLoading] = useState(false)

    const kareoDate = useRef({"from":"","to":""})
    
    const [patientDetailsVisible, setPatientDetailsVisible] = useState(false)
    const renderedFormData = useRef([])
  
    

    const [keyWords, setKeyWords] = useState([])
    const [selectedDayRange, setSelectedDayRange] = useState({
      from: null,
      to: null
    });

  const [patientData, setPatientData] = useState("")


  const providerData = async () => {
    let providers = await syncServiceLocationFromKareo("GET")
    let data = JSON.parse(providers.d)
    setPatientData(providers.d)
  }
  
    useEffect(()=>{
      providerData()
      
    },[])
    const syncKareo = async (e) => {
        setLoading(true)
         
            let a = await syncServiceLocationFromKareo("INSERT")
            location.reload()
          setLoading(false)
    }
return (
    <>
    {/* <MyCalendar></MyCalendar> */}
    {/* <CContainer></CContainer> */}
    <CCard className="m-2" >
        <CCardBody>
        {/* <CButton className="m-2" variant="outline" color="success" onClick={handleonClick} >
           Add New Patient
    </CButton> */}
    <Button className="m-2" type="primary" variant="outline" loading={loading} onClick={syncKareo} >
           Sync Providers from Kareo
    </Button>

        </CCardBody>
    </CCard>
    
    <CustomAgGrid callFrom="Patient"  options={patientData} btnList={buttonList}>

    </CustomAgGrid>
    

    </>
)
}

export default ServiceLocationKareo